import type { BugReportActionEntry } from '@clareefai/types';

export class BugReporterActionLog {
  private entries: BugReportActionEntry[] = [];
  private maxSize: number;

  constructor(maxSize: number) {
    this.maxSize = maxSize;
  }

  push(entry: BugReportActionEntry) {
    this.entries.push(entry);
    if (this.entries.length > this.maxSize) {
      this.entries.shift();
    }
  }

  getEntries(): BugReportActionEntry[] {
    return [...this.entries];
  }

  clear() {
    this.entries = [];
  }
}

export const bugReporterActionLog = new BugReporterActionLog(50);
